import { defaultUiConfig } from "~config/sport/defaultsUi";
import type { UiConfiguration } from "~types/uiConfiguration";

export const basketballUiConfig: UiConfiguration = {
  ...defaultUiConfig,
  pages: {
    ...defaultUiConfig.pages,
    entityStatistic: { enabled: true },
    reports: {
      fixturePlayByPlayFlaggedEventList: { ...defaultUiConfig.pages.reports.fixturePlayByPlayFlaggedEventList },
      reportsConfig: [
        {
          key: "seasonEntitiesStatistic",
          notificationMessageIntlKey: "reports.seasonEntitiesStatistic.started",
          titleIntlKey: "reports.seasonEntitiesStatistic",
          descriptionIntlKey: "reports.seasonEntitiesStatistic.description",
          generateReportUrl: (sport: string, organizationId: string, seasonId: string) =>
            `${sport}/o/${organizationId}/reports/entities/statistic/in/season/${seasonId}`,
        },
        {
          key: "seasonPersonsStatistic",
          notificationMessageIntlKey: "reports.seasonPersonsStatistic.started",
          titleIntlKey: "reports.seasonPersonsStatistic",
          descriptionIntlKey: "reports.seasonPersonsStatistic.description",
          generateReportUrl: (sport: string, organizationId: string, seasonId: string) =>
            `${sport}/o/${organizationId}/reports/persons/statistic/in/season/${seasonId}`,
        },
        {
          key: "seasonLeadersStatistic",
          notificationMessageIntlKey: "reports.seasonLeadersStatistic.started",
          titleIntlKey: "reports.seasonLeadersStatistic",
          descriptionIntlKey: "reports.seasonLeadersStatistic.description",
          generateReportUrl: (sport: string, organizationId: string, seasonId: string) =>
            `${sport}/o/${organizationId}/reports/leaders/statistic/in/season/${seasonId}`,
        },
      ],
    },
  },
};
